import { useTranslation } from 'react-i18next';
import { IconButton } from '@asset-metrix/portal-ui';

type PageCustomizationButtonProps = {
  enabled?: boolean;
  onClick?: () => void;
};

export function PageCustomizationButton({
  enabled,
  onClick,
}: PageCustomizationButtonProps) {
  const { t } = useTranslation();

  if (enabled !== true) {
    return null;
  }

  return (
    <IconButton
      action={{
        title: t('app.page.editAction.label.customizePage'),
        icon: {
          name: 'page-customization',
          svgIcon: true,
        },
      }}
      loading={false}
      onClick={onClick}
    />
  );
}
